// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lBw2D","modalContent":"Modal_modalContent__Squ56","modalHeader":"Modal_modalHeader__AX2iT","modalTitle":"Modal_modalTitle__AejrG"};